import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Spinner: ComponentStyleConfig = {
  defaultProps: {
    color: 'primary.600',
  },
}
